import axios from 'axios';

// API Base URL - always use production server
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.postacim.net/api';

// Storage URL - Laravel storage dizini için
export const STORAGE_BASE_URL = process.env.REACT_APP_STORAGE_URL || 'https://api.postacim.net/storage';

// Axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000, // 2 dakika
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('userToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { api };
export default api;
